import { render, staticRenderFns } from "./FormRequest.vue?vue&type=template&id=54b16e18&"
import script from "./FormRequest.vue?vue&type=script&lang=ts&"
export * from "./FormRequest.vue?vue&type=script&lang=ts&"
import style0 from "./FormRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports